import React from "react";
import { useLocation } from "react-router-dom";
import B2BHeader from "../../components/b2b/B2BHeader";
import { ROUTE_COMPANY_JOB_DETAILS } from "../../constants/routes";

interface PublicLayoutProps {
  children: React.ReactNode;
}

const PublicLayout: React.FC<PublicLayoutProps> = ({ children }): JSX.Element => {
  const location = useLocation();
  const roles = localStorage.getItem("roles");
  
  // Check if current route is company-job-details
  const isCompanyJobDetailsRoute = location.pathname.startsWith(ROUTE_COMPANY_JOB_DETAILS);
  
  // Check if user is NOT a candidate (has employer/admin roles)
  // Candidates have "job_seeker" role, non-candidates have roles like EMPLOYER_USER, EMPLOYER_JOB_ADMIN, seevi_admin, admin
  const isNotCandidate = roles && roles.length > 0 && !roles.includes("job_seeker");
  
  // Show B2BHeader for company-job-details route when user is not a candidate
  const shouldShowHeader = isCompanyJobDetailsRoute && isNotCandidate;
  
  return (
    <div>
      {shouldShowHeader && <B2BHeader />}
      {children}
    </div>
  );
};

export default PublicLayout;
